import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { Gear, Globe } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

interface LanguageSettingsButtonProps {
  className?: string;
  onClick?: () => void;
}

function LanguageSettingsButton({
  className,
  onClick,
}: LanguageSettingsButtonProps) {
  const { t } = useTranslation("common");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          onClick={onClick}
          className={cn(
            "relative p-[0.37rem] h-fit w-fit rounded-full overflow-hidden group",
            className
          )}
          aria-label={t("languageAndSettings")}
        >
          <div
            className="absolute inset-0 flex items-center justify-center"
            style={{
              clipPath: "polygon(0 0, 100% 0, 0 100%)",
            }}
          >
            <span
              className="overflow-hidden font-normal rounded-full"
              style={{
                fontSize: "3rem",
                lineHeight: "1",
              }}
              aria-hidden="true"
            >
              {/* {flagEmoji} */}
              <Globe className="!w-10 !h-10" />
            </span>
          </div>
          <div
            className="absolute inset-0 flex items-center justify-center"
            style={{
              clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
            }}
          >
            <Gear
              className="!w-10 !h-10 group-hover:animate-spin-once ease-in-out duration-100"
              aria-hidden="true"
            />
          </div>
          <div
            className="absolute top-0 left-0 w-full h-full rounded-full pointer-events-none"
            style={{
              background:
                "linear-gradient(-45deg, transparent 48%, currentColor 48%, currentColor 52%, transparent 52%)",
            }}
          />
          <div className="w-8 h-8 opacity-0" aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent
        side="right"
        className="bg-popover-dark text-popover-dark-foreground border-popover-dark"
      >
        <span className="select-none">{t("languageAndSettings")}</span>
      </TooltipContent>
    </Tooltip>
  );
}

export default LanguageSettingsButton;
